<template lang="pug">
  div.access.user-update
    e-form-modal(
    ref="modalForm"
     @submitModalForm="sendForm()"
     @deleteItem="deleteItem()"
     :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        //-  табы ...
          e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          )
      slot
          e-form(:formValidator="formValidator")
            //- вкладка ОБЩИЕ СВЕДЕНИЯ
            div.body
              div
                e-form-group.year-field(
                  inputType= 'dsd'
                  label="Год"
                  tabView='tab'
                  name = 'year'
                )
                  el-input-number(v-model='fields.year' )
              div
                div.col.col-block
                  el-checkbox(
                    v-model='fields.active'
                  ) Видимость потока на карте
              div.col
                e-form-group.mo-search(
                  inputType="suggestion"
                  :suggestionEndpoint='getMOEndpoint'
                  :model='fields'
                  tabView='tab'
                  name = 'geoName'
                  @selectItem="selectMoItemEvnt"
                  @change='moItemChangeEvnt'
                  :addBorder="true"
                  label="Наименование геообъекта..."
                  :useInnerSearch="false"
                  @clear=''
                )
            div.comments(v-if='fields.comment')
              ul
                li(v-for='com in fields.comment') {{com}}
            div.thread-tko-elements.body(v-for="(p, ind, k) in sortedPoints" ':key'="p.delta")
              div.col-1.thred-point-element(
                @click='changeType(p)'
                v-bind='pointProps(p.color_key)'
              )
              div.col-1.point-name Плечо \#{{p.delta}}
              div.col-1.mover
                el-button(icon='el-icon-arrow-up' sizee='mini' ':disabled'='p.delta == 1' title='поднять на 1' @click='moveTKKOshka(p,"up")' )
                el-button(icon='el-icon-arrow-down' sizee='mini' ':disabled'='p.delta == constants.maxTkoElements' title='опустить на 1' @click='moveTKKOshka(p,"down")')

              div.col
                e-form-group.tko-search(
                  inputType="suggestion"
                  :suggestionEndpoint='getTKOEndpoint'
                  tabView='tab'
                  :label="constants.tkoFieldTitle"
                  :model='p'
                  name = 'tkoName'
                  @selectItem="selectTkoItemEvnt(p, $event)"
                  @change='tkoItemChangeEvnt(p)'
                  :addBorder="true"
                  placeholder='Наименование ТКО-объекта...'
                  :useInnerSearch="false"
                )
              div.col
                e-form-group(
                  name="size_tonn"
                  inputType="input"
                  label="Масса отходов, тонн"
                  :model="p"
                  tabView='tab'
                  autocomplete="off"
                )
              div.col
                e-form-group(
                  name="distance"
                  inputType="input"
                  label="Расстояние до объекта, км"
                  :model="p"
                  tabView='tab'
                  autocomplete="off"
                  :disabled="true"
                )
    el-dialog(
      v-if='threadPointObjToColorSet != null'
      title="Замена цвета(типа) стрелки"
      width="30%"
      ':visible'='true'
      @close='threadPointObjToColorSet=null'
      ':append-to-body'='true'
    )
      el-radio-group(v-model='threadPointObjToColorSet.color_key')
        el-radio-button(v-for='title, key in constants.pointTypes' ':label'='key' ':key'='key' ':value'='key') {{title}}



</template>
<style>
  .thred-point-element {cursor: default;width: 1.5em;border:1px solid #ddd; border-radius: 0.25em;cursor: pointer;}
  .thread-tko-elements .point-name {transform: rotate(-90deg); align-self: center; height: 1px;}

  .mo-search, .tko-search {height: unset;}
  .thread-tko-elements .body {margin:0.5em 0; padding: 0;}
  .mover {display: flex; flex-direction: column; justify-content: space-around; align-items: center;}
  .mover button {padding: 0.5em;}
  .mover i {height: auto;width:auto;margin: 0;}
</style>
<script>
  import {atu, access, map as mapEndpoints, threads, tko} from '../../api/api-endpoints.js'
  import adminForm from './mixins/admin-form.js'
  import axios from "axios";

  export default {
    mixins: [adminForm],
    data () {
      return {
        threadPointObjToColorSet: null,
        fields: {
          geoId: null,
          geoName: '',
          year: 0,
          points: [],
        },
        errors: null
      }
    },

    created() {
      this.$store.commit('threadConstantLoad');
      if (!this.fields.year) {
        let date = new Date();
        this.$set(this.fields, 'year', date.getFullYear());
      }
    },
    mounted() {
      this.getDistance(this.$route.params.id)
    },
    computed: {
      constants() {
        return this.$store.state.threadConstant;
      },
      sortedPoints() {
        console.log(this.fields.points.length,'len');
        if (!this.fields.points.length && this.constants.maxTkoElements) {
          let points = [];
          for(let i = 0; i < this.constants.maxTkoElements; i++) {
            points.push({delta: i + 1, distance: 0, size_tonn: null, tkoName: '', tkoId: null});
          }
          this.$set(this.fields, 'points', points);
        }
        return this.fields.points.sort((a, b) => {
          if (a.delta > b.delta)
            return 1;
          if (a.delta < b.delta)
            return -1;
          return 0;
        });
      },
      formTitle () {
        if (this.fields && this.fields.geoId) {
          return 'Редактирование потока из "' + this.fields.geoName + '"';
        }
        return this.$translate('Новый поток');
      }
    },
    methods: {
      // назначение стилей для отрисовки точки ..
      pointProps(pointType) {
        let props = {};
        if (!pointType) {
          return props;
        }
        if (this.constants.pointTypesColors) {
          props.style = {background: '#' + this.constants.pointTypesColors[pointType]};
        }
        if (this.constants.pointTypes) {
          props.title = this.constants.pointTypes[pointType];
        }
        return props;
      },
      // изменение типа стрелки ...
      changeType(point){
        this.threadPointObjToColorSet = point;
      },
      // выбран из списка геообъект МО
      selectMoItemEvnt(e) {
        this.fields.geoName = e.name;
        this.fields.geoId = e.id;
      },
      //выбран объект ТКО
      selectTkoItemEvnt(p, obj) {
        p.tkoId = obj.id;
        p.tkoName = obj.name;
      },
      tkoItemChangeEvnt(p) {
        if (!p.tkoName) {
          p.tkoId = null;
        }
      },
      moItemChangeEvnt() {
        if (!this.fields.geoName) {
          this.fields.geoId = null;
        }
      },
      getMOEndpoint (model, q) {
        return atu.atuObjects({query: {'per-page': -1, q/*, 'rootLevelOnly': 1*/}});
      },
      getTKOEndpoint (model, q) {
        return tko.objectSimple({query: { q }});
      },
      // относительное перемещение ткошек ..
      moveTKKOshka(point, direction) {
        let newDelta = point.delta;
        let oldDelta = point.delta;
        let point2;
        switch(direction) {
        case 'up':
          newDelta--;
          break;
        case 'down':
          newDelta++;
          break;
        }
        for (let i = 0; i < this.fields.points.length; i++) {
          if (this.fields.points[i].delta == newDelta) {
            point2 = i;
            break;
          }
        }
        if (typeof point2 != 'undefined') {
          this.$set(this.fields.points[point2], 'delta', oldDelta);
          point.delta = newDelta;
        }
      },

      update () {
        adminForm.methods.update.call(this)
      },
      // send post for correct change status and avatar
      getStoreAction () {
        return 'createModel'
      },
      getRolesUrl () {
        return access.groups()
      },
      getDeleteUrl (id){
        return access.userDelete(id)
      },
      getUpdateOrCreateUrl(route) {
        return threads.one(this.$route.params.id)
      },
      getItemEndpoint(route){
        if (!route.params.id) {
          return null
        }
        return threads.one(route.params.id);
      },
      async getDistance(route) {
        const url = threads.distanceToObject(route)
        const bodyParameters = {
          geoId: this.fields.geoId,
        };
        const config = {
          headers: { Authorization: `Bearer ${this.$store.getters.authToken}` }
        };

        await axios.post(
          url,
          bodyParameters,
          config
        ).then(response => {
          if (response.data.points) {
            this.fields.points = response.data.points;
          }
        });
      },
    }
  }
</script>
